import { Controller } from "stimulus";

// Holds back an episode's season change while a sold season's buyers would gain or lose it: the change
// event is stopped in the capture phase, before auto-save sees it, and re-dispatched once confirmed.
export default class extends Controller {
  static targets = ["select", "dialog", "list"];

  connect() {
    this.previous = this.selectTarget.value;
    this.confirmed = false;
    this.guard = this.guard.bind(this);
    // Browsers fire input then change; auto-save arms its timer on input, so both are held back.
    this.element.addEventListener("input", this.guard, true);
    this.element.addEventListener("change", this.guard, true);
  }

  disconnect() {
    this.element.removeEventListener("input", this.guard, true);
    this.element.removeEventListener("change", this.guard, true);
  }

  guard(event) {
    if (event.target !== this.selectTarget || this.confirmed) return;

    const from = this.optionFor(this.previous);
    const to = this.optionFor(this.selectTarget.value);
    if (!this.buyers(from) && !this.buyers(to)) {
      if (event.type === "change") this.previous = this.selectTarget.value;
      return;
    }

    event.stopPropagation();
    if (event.type === "change") {
      this.describe(from, to);
      this.dialogController.open();
    }
  }

  onConfirm() {
    this.dialogController.close();
    this.confirmed = true;
    this.selectTarget.dispatchEvent(new Event("input", { bubbles: true }));
    this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }));
    this.confirmed = false;
    this.previous = this.selectTarget.value;
  }

  onCancel() {
    this.dialogController.close();
    this.selectTarget.value = this.previous;
    this.selectTarget.focus();
  }

  optionFor(value) {
    return Array.from(this.selectTarget.options).find((option) => option.value === value);
  }

  buyers(option) {
    return Number(option?.dataset.buyerCount || 0);
  }

  describe(from, to) {
    const name = to?.dataset.name;
    const title = name ? `Move to ${name}?` : `Remove from ${from.dataset.name}?`;
    this.dialogTarget.querySelector("[data-confirm-dialog-part='title']").textContent = title;
    this.dialogTarget.querySelector("[data-confirm-dialog-part='confirm']").textContent = name ? "Move episode" : "Remove from season";

    this.listTarget.replaceChildren();
    if (this.buyers(from)) this.addLine(from, "They'll lose access to this episode.");
    if (this.buyers(to)) this.addLine(to, "They'll get it.");
  }

  addLine(option, outcome) {
    const count = this.buyers(option);
    const item = document.createElement("li");
    const strong = document.createElement("b");
    strong.textContent = `${count} ${count === 1 ? "buyer" : "buyers"}`;
    item.append(`${option.dataset.name} has `, strong, `. ${outcome}`);
    this.listTarget.append(item);
  }

  get dialogController() {
    return this.application.getControllerForElementAndIdentifier(this.dialogTarget, "block--confirm-dialog-component");
  }
}
